import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class Availability extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId, inventoryId, zoneId = null }) {
        if (!organizationId || !eventId || !inventoryId) {
            throw new ArgumentError(`[Model][Availability][getAll] organizationId, eventId and inventoryId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/zones${zoneId ? '/' + zoneId : ''}`;
    }

    static async refreshCache({ organizationId, chartId, inventoryId }) {
        if (!organizationId || !chartId || !inventoryId) {
            throw new ArgumentError(`[Model][Availability][refreshCache] organizationId, chartId and inventoryId are mandatory`);
        }

        const url = `/ticket/organizations/${organizationId}/charts/${chartId}/inventories/${inventoryId}/refresh-availability-cache`;

        return fetcher.post(url, {});
    }
}
